import { Provider } from 'react-redux'
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom'
import { store } from './config/store'
import { AuthProvider } from './contexts/AuthContext'
import LandingPage from './features/landing/lib/page'
import AuthCallbackPage from './features/auth/lib/AuthCallbackPage'
import EventPage from './features/events/lib/page'
import DashboardPage from './features/dashboard/lib/page'
import EventDetailPage from './features/events/lib/Detail.page'
import SearchPage from './features/landing/lib/Search.page'
import CreateEventPage from './features/events/lib/Create.page'
import ManageEventPage from './features/events/lib/AcceptAttending.page'
import AcceptCoHostInvitationPage from './features/events/lib/AcceptCoHostInvitation.page'
import EditEventPage from './features/events/lib/Edit.page'
import AcceptEventUserInvitationPage from './features/events/lib/AcceptEventUserInvitation.page'
import EditProfilePage from './features/auth/lib/EditProfile.page'
import AdminPage from './features/admin/lib/page'
import { AdminGuard } from './features/auth/components/AuthGuard'

// Pages

function App() {
  return (
    <Provider store={store}>
      <Router>
        <AuthProvider>
          <Routes>
            {/* Public routes */}
            <Route 
              path="/" 
              element={<LandingPage />} 
            />
            
            {/* Auth callback for OAuth */}
            <Route
              path="/auth/callback"
              element={<AuthCallbackPage />}
            />
            
            {/* Protected routes */}
            <Route 
              path="/dashboard" 
              element={<DashboardPage />} 
            />

            {/* Admin route */}
            <Route
              path="/backoffice"
              element={
                <AdminGuard>
                  <AdminPage />
                </AdminGuard>
              }
            />
            
            {/* Event routes with parameters */}
            <Route 
              path="/events/:eventId" 
              element={<EventPage />}
            />
            
            <Route 
              path="/event/:eventId" 
              element={<EventDetailPage />}
            />
            {/* Event management route with token - NUEVA RUTA */}
            <Route 
              path="/events/:eventId/helping" 
              element={<ManageEventPage />}
            />
            
            {/* Ruta para aceptar invitación de co-host */}
            <Route 
              path="/events/:eventId/cohost" 
              element={<AcceptCoHostInvitationPage />}
            />

            {/* Accept invitation user event */}
            <Route 
              path="/events/:eventId/accept"
              element={<AcceptEventUserInvitationPage />}
            />

            {/* EVENT edit route */}
            <Route 
              path="/events/:eventId/edit" 
              element={<EditEventPage />}
            />

          

            {/* Search route - ahora acepta parámetros de query */}
            <Route
              path="/search"
              element={<SearchPage />}
            />

            <Route
              path="/create"
              element={<CreateEventPage />}
            />
            
            {/* Edit Profile route */}
            <Route 
              path="/profile/edit" 
              element={<EditProfilePage />} 
            />
            
            {/* Catch all - redirect to home */}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </AuthProvider>
      </Router>
    </Provider>
  )
}

export default App